
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93dcbQaPYAFeMeta } from "/var/www/homedelimercado.com/pages/[...slug].vue?macro=true";
import { default as _404LwNQpoBLVvMeta } from "/var/www/homedelimercado.com/pages/404.vue?macro=true";
import { default as LoginjQLbiiI0fmMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Login.vue?macro=true";
import { default as MostSoldgtHYmw0q6xMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/MostSold.vue?macro=true";
import { default as AccessesFqWri8M2HqMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Partials/Accesses.vue?macro=true";
import { default as NewUsersq2KmSaQTUdMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Partials/NewUsers.vue?macro=true";
import { default as PagesMostVisitedPPIwhr9NzHMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Partials/PagesMostVisited.vue?macro=true";
import { default as ProductsAggregatedCartWVfFEPCEjQMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Partials/ProductsAggregatedCart.vue?macro=true";
import { default as ProductsMostSoldYYIWFiktxSMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Partials/ProductsMostSold.vue?macro=true";
import { default as ProductsMostVisitedNoYt0EMiC7Meta } from "/var/www/homedelimercado.com/pages/admin/analytics/Partials/ProductsMostVisited.vue?macro=true";
import { default as SalesBehaviourec37xJ1cYIMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Partials/SalesBehaviour.vue?macro=true";
import { default as SalesDh3QE6G8JYMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Sales.vue?macro=true";
import { default as VisitsUSDEJ1errWMeta } from "/var/www/homedelimercado.com/pages/admin/analytics/Visits.vue?macro=true";
import { default as _91id_93dl5EoMbMqtMeta } from "/var/www/homedelimercado.com/pages/admin/attributes/[id].vue?macro=true";
import { default as createY17bcfczxlMeta } from "/var/www/homedelimercado.com/pages/admin/attributes/create.vue?macro=true";
import { default as indexr2AmdIeI3pMeta } from "/var/www/homedelimercado.com/pages/admin/attributes/index.vue?macro=true";
import { default as _91id_93Ybs8GJgyGhMeta } from "/var/www/homedelimercado.com/pages/admin/banners/[id].vue?macro=true";
import { default as createhRtx251CzYMeta } from "/var/www/homedelimercado.com/pages/admin/banners/create.vue?macro=true";
import { default as indexYfsDhnQaLIMeta } from "/var/www/homedelimercado.com/pages/admin/banners/index.vue?macro=true";
import { default as _91id_93SkE0OmwTkDMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/categories/[id].vue?macro=true";
import { default as createolJvQk2mdCMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/categories/create.vue?macro=true";
import { default as index1lX5T0n5QYMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/categories/index.vue?macro=true";
import { default as _91id_935qpHQGCj5UMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/keywords/[id].vue?macro=true";
import { default as createiMUvC056jHMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/keywords/create.vue?macro=true";
import { default as indexBYifplEfLKMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/keywords/index.vue?macro=true";
import { default as _91id_93A9RvszUyKzMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/posts/[id].vue?macro=true";
import { default as createI7VlMOelhAMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/posts/create.vue?macro=true";
import { default as indexV7941fcYpsMeta } from "/var/www/homedelimercado.com/pages/admin/blogs/posts/index.vue?macro=true";
import { default as _91id_93eLBeJS49luMeta } from "/var/www/homedelimercado.com/pages/admin/brands/[id].vue?macro=true";
import { default as createkYo8Ay7voiMeta } from "/var/www/homedelimercado.com/pages/admin/brands/create.vue?macro=true";
import { default as indexp9UtDZ7fOdMeta } from "/var/www/homedelimercado.com/pages/admin/brands/index.vue?macro=true";
import { default as _91id_932kT1mgIb4kMeta } from "/var/www/homedelimercado.com/pages/admin/categories/[id].vue?macro=true";
import { default as CreateTOZKH2eCPkMeta } from "/var/www/homedelimercado.com/pages/admin/categories/Create.vue?macro=true";
import { default as indexWUnTdzkqTtMeta } from "/var/www/homedelimercado.com/pages/admin/categories/index.vue?macro=true";
import { default as _91id_93jqF1tTyXyAMeta } from "/var/www/homedelimercado.com/pages/admin/coins/[id].vue?macro=true";
import { default as createumKdFWw67sMeta } from "/var/www/homedelimercado.com/pages/admin/coins/create.vue?macro=true";
import { default as indexezTllIlrBJMeta } from "/var/www/homedelimercado.com/pages/admin/coins/index.vue?macro=true";
import { default as indexsXtFRMrOzSMeta } from "/var/www/homedelimercado.com/pages/admin/criterias/index.vue?macro=true";
import { default as createv9nIl2VwjxMeta } from "/var/www/homedelimercado.com/pages/admin/exchangeRates/create.vue?macro=true";
import { default as CreateBatchBEbOPG7za3Meta } from "/var/www/homedelimercado.com/pages/admin/exchangeRates/CreateBatch.vue?macro=true";
import { default as Edit5wF18qvub0Meta } from "/var/www/homedelimercado.com/pages/admin/exchangeRates/Edit.vue?macro=true";
import { default as indexhDq11jBTADMeta } from "/var/www/homedelimercado.com/pages/admin/exchangeRates/index.vue?macro=true";
import { default as _91id_93kD6Uny2kAyMeta } from "/var/www/homedelimercado.com/pages/admin/gift_Cards/[id].vue?macro=true";
import { default as createqWGfdP8GgbMeta } from "/var/www/homedelimercado.com/pages/admin/gift_Cards/create.vue?macro=true";
import { default as indexJ0uADUlgeCMeta } from "/var/www/homedelimercado.com/pages/admin/gift_Cards/index.vue?macro=true";
import { default as CreateiVHcUX2nPYMeta } from "/var/www/homedelimercado.com/pages/admin/invoices/Create.vue?macro=true";
import { default as index3rD5GmPOH7Meta } from "/var/www/homedelimercado.com/pages/admin/invoices/index.vue?macro=true";
import { default as _91id_93NTnDOnRkYMMeta } from "/var/www/homedelimercado.com/pages/admin/offers/[id].vue?macro=true";
import { default as CreatezH3XijcUTTMeta } from "/var/www/homedelimercado.com/pages/admin/offers/Create.vue?macro=true";
import { default as indexRHn7yVXCWvMeta } from "/var/www/homedelimercado.com/pages/admin/offers/index.vue?macro=true";
import { default as _91id_93aSQvdUWYwgMeta } from "/var/www/homedelimercado.com/pages/admin/order_status/[id].vue?macro=true";
import { default as createpr5VBxb7qKMeta } from "/var/www/homedelimercado.com/pages/admin/order_status/create.vue?macro=true";
import { default as indexDhjiStlgZdMeta } from "/var/www/homedelimercado.com/pages/admin/order_status/index.vue?macro=true";
import { default as showaQL3943AhYMeta } from "/var/www/homedelimercado.com/pages/admin/orders/[order]/show.vue?macro=true";
import { default as indexvkmvLTGW5eMeta } from "/var/www/homedelimercado.com/pages/admin/orders/index.vue?macro=true";
import { default as _91id_93mRERI9GZe0Meta } from "/var/www/homedelimercado.com/pages/admin/point_of_sales/[id].vue?macro=true";
import { default as createEiKzcJpZuEMeta } from "/var/www/homedelimercado.com/pages/admin/point_of_sales/create.vue?macro=true";
import { default as indexUICyTJAwuPMeta } from "/var/www/homedelimercado.com/pages/admin/point_of_sales/index.vue?macro=true";
import { default as editSlGiIsKwvZMeta } from "/var/www/homedelimercado.com/pages/admin/products/[slug]/edit.vue?macro=true";
import { default as Createa9uRdbm4FKMeta } from "/var/www/homedelimercado.com/pages/admin/products/Create.vue?macro=true";
import { default as listxWKWPXlpjYMeta } from "/var/www/homedelimercado.com/pages/admin/products/list.vue?macro=true";
import { default as indexucPhkXmJqFMeta } from "/var/www/homedelimercado.com/pages/admin/reports/catalog/index.vue?macro=true";
import { default as indexbmcUlIBzcMMeta } from "/var/www/homedelimercado.com/pages/admin/reports/inventory/index.vue?macro=true";
import { default as indexUlDQD2qFO4Meta } from "/var/www/homedelimercado.com/pages/admin/reports/movements/index.vue?macro=true";
import { default as indexmA76iQVHiOMeta } from "/var/www/homedelimercado.com/pages/admin/reports/orders/index.vue?macro=true";
import { default as indexarMCXkb22OMeta } from "/var/www/homedelimercado.com/pages/admin/reports/sale/index.vue?macro=true";
import { default as indexzOVIDtlvOhMeta } from "/var/www/homedelimercado.com/pages/admin/reports/salesaccounting/index.vue?macro=true";
import { default as indexhSwh6VqFbXMeta } from "/var/www/homedelimercado.com/pages/admin/reports/soldProduct/index.vue?macro=true";
import { default as indexgw9nznGjK1Meta } from "/var/www/homedelimercado.com/pages/admin/reports/unify_sale/index.vue?macro=true";
import { default as indexA11LGoXs90Meta } from "/var/www/homedelimercado.com/pages/admin/reviews/index.vue?macro=true";
import { default as _91id_932l68WQIXtvMeta } from "/var/www/homedelimercado.com/pages/admin/roles/[id].vue?macro=true";
import { default as CreateCIhX8Qwu7kMeta } from "/var/www/homedelimercado.com/pages/admin/roles/Create.vue?macro=true";
import { default as indexNTb7xfKfxJMeta } from "/var/www/homedelimercado.com/pages/admin/roles/index.vue?macro=true";
import { default as indexNvs3aFOcGOMeta } from "/var/www/homedelimercado.com/pages/admin/sales_buy_card/index.vue?macro=true";
import { default as CustomizationuHy6mXphSvMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Customization.vue?macro=true";
import { default as GeneralsHurC1YHTsAMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Generals.vue?macro=true";
import { default as ContactsQYoKYdiC5dMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/Contacts.vue?macro=true";
import { default as FrequentAsksqdQlLzB96PMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/FrequentAsks.vue?macro=true";
import { default as InformationSectionsI1lPnlkZDMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/InformationSection.vue?macro=true";
import { default as LocalPickupcGQQ5X5e2eMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/LocalPickup.vue?macro=true";
import { default as Misc4FOiQlgDRhMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/Misc.vue?macro=true";
import { default as MiscellaneousLD6FWySLF2Meta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/Miscellaneous.vue?macro=true";
import { default as NotificationstwsQeFKfJRMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/Notifications.vue?macro=true";
import { default as PayFormItemUwjJk5horqMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/PayFormItem.vue?macro=true";
import { default as PayFormsQJWfArTnAVMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/PayForms.vue?macro=true";
import { default as ProductsInventaryGLkqKFzzRiMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/ProductsInventary.vue?macro=true";
import { default as RelatedProductStrategiesFbBRMes3NXMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/RelatedProductStrategies.vue?macro=true";
import { default as ScheduleFormjdTaMo6C1qMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/ScheduleForm.vue?macro=true";
import { default as ScheduleStoreBNw4kliWDHMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/ScheduleStore.vue?macro=true";
import { default as ShipmentT6gNVyU95XMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/Shipment.vue?macro=true";
import { default as ShipmentProvincebagDzq5P8XMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/ShipmentProvince.vue?macro=true";
import { default as ShipmentSelectLocationsWhCXw3y8y7Meta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/ShipmentSelectLocations.vue?macro=true";
import { default as ShipmentUnitRangecrBud8erKLMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/ShipmentUnitRange.vue?macro=true";
import { default as ShoppingCardcCjm0F3DddMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/ShoppingCard.vue?macro=true";
import { default as StorexInjbV2ik0Meta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/Store.vue?macro=true";
import { default as TwiceTimeZb9fiGHatAMeta } from "/var/www/homedelimercado.com/pages/admin/settings/Partials/TwiceTime.vue?macro=true";
import { default as _91id_938l8CNgDrsSMeta } from "/var/www/homedelimercado.com/pages/admin/shopping_card/[id].vue?macro=true";
import { default as indexVcPqq7LckNMeta } from "/var/www/homedelimercado.com/pages/admin/shopping_card/index.vue?macro=true";
import { default as _91id_93Fej4WDtL0aMeta } from "/var/www/homedelimercado.com/pages/admin/users/[id].vue?macro=true";
import { default as create2xH4OYtJCfMeta } from "/var/www/homedelimercado.com/pages/admin/users/create.vue?macro=true";
import { default as indexyukLnHmRuSMeta } from "/var/www/homedelimercado.com/pages/admin/users/index.vue?macro=true";
import { default as ConfirmPasswordST1pfyECR8Meta } from "/var/www/homedelimercado.com/pages/Auth/ConfirmPassword.vue?macro=true";
import { default as ForgotPasswordjGXDLo6BFIMeta } from "/var/www/homedelimercado.com/pages/Auth/ForgotPassword.vue?macro=true";
import { default as LoginFkowABroAEMeta } from "/var/www/homedelimercado.com/pages/Auth/Login.vue?macro=true";
import { default as RegisterEIahbFB2sFMeta } from "/var/www/homedelimercado.com/pages/Auth/Register.vue?macro=true";
import { default as ResetPasswordiOkK9leeUBMeta } from "/var/www/homedelimercado.com/pages/Auth/ResetPassword.vue?macro=true";
import { default as VerifyEmailkfYn3gWhdkMeta } from "/var/www/homedelimercado.com/pages/Auth/VerifyEmail.vue?macro=true";
import { default as _91blog_93u9p5vBjddYMeta } from "/var/www/homedelimercado.com/pages/blog/[blog].vue?macro=true";
import { default as indexfBJxNRbyOYMeta } from "/var/www/homedelimercado.com/pages/blog/index.vue?macro=true";
import { default as indexUND3UW0LpvMeta } from "/var/www/homedelimercado.com/pages/Cart/index.vue?macro=true";
import { default as _91encoded_93R9y0VWiZwCMeta } from "/var/www/homedelimercado.com/pages/Cart/share-cart/[encoded].vue?macro=true";
import { default as indexqQxF6b70YiMeta } from "/var/www/homedelimercado.com/pages/Contact-Us/index.vue?macro=true";
import { default as Index3UdxOYLspTMeta } from "/var/www/homedelimercado.com/pages/Distribution/Index.vue?macro=true";
import { default as Createwxo1oCAqjiMeta } from "/var/www/homedelimercado.com/pages/ExchangeRates/Create.vue?macro=true";
import { default as CreateBatchJ97q13wrnWMeta } from "/var/www/homedelimercado.com/pages/ExchangeRates/CreateBatch.vue?macro=true";
import { default as EditFK3Hk5MNXYMeta } from "/var/www/homedelimercado.com/pages/ExchangeRates/Edit.vue?macro=true";
import { default as IndexCyxnMnBo0CMeta } from "/var/www/homedelimercado.com/pages/ExchangeRates/Index.vue?macro=true";
import { default as indexrxXs0FjWVLMeta } from "/var/www/homedelimercado.com/pages/Frequent-Ask/index.vue?macro=true";
import { default as index0PCKvsrJHVMeta } from "/var/www/homedelimercado.com/pages/index.vue?macro=true";
import { default as infomip7cSV9rXMeta } from "/var/www/homedelimercado.com/pages/info.vue?macro=true";
import { default as _91InformationPage_93Trr79Eaf96Meta } from "/var/www/homedelimercado.com/pages/information/[InformationPage].vue?macro=true";
import { default as index6emmz8sDbsMeta } from "/var/www/homedelimercado.com/pages/Offers/index.vue?macro=true";
import { default as error_45page7Ltc4yIn0fMeta } from "/var/www/homedelimercado.com/pages/orders/[order]/error-page.vue?macro=true";
import { default as redirect_45pagez8hSCWKOFHMeta } from "/var/www/homedelimercado.com/pages/orders/[order]/redirect-page.vue?macro=true";
import { default as showMQvpG22Bw5Meta } from "/var/www/homedelimercado.com/pages/orders/[order]/show.vue?macro=true";
import { default as success_45pageAGnsISyNkyMeta } from "/var/www/homedelimercado.com/pages/orders/[order]/success-page.vue?macro=true";
import { default as _91id_93cmSCRXXXoPMeta } from "/var/www/homedelimercado.com/pages/payment_shopping_card/[id].vue?macro=true";
import { default as _91product_93Lvf4yorSajMeta } from "/var/www/homedelimercado.com/pages/Products/[product].vue?macro=true";
import { default as edit4MzmGRMhnAMeta } from "/var/www/homedelimercado.com/pages/Products/[slug]/edit.vue?macro=true";
import { default as CreateNH34B29vxYMeta } from "/var/www/homedelimercado.com/pages/Products/Create.vue?macro=true";
import { default as IndexDfZAfuukUwMeta } from "/var/www/homedelimercado.com/pages/Products/Index.vue?macro=true";
import { default as _91product_93cs0M4QPtVgMeta } from "/var/www/homedelimercado.com/pages/Products/Review/Read/[product].vue?macro=true";
import { default as _91product_93GSR8VilZn8Meta } from "/var/www/homedelimercado.com/pages/Products/Review/Write/[product].vue?macro=true";
import { default as SuccessPageOj40QgXRjQMeta } from "/var/www/homedelimercado.com/pages/Products/SuccessPage.vue?macro=true";
import { default as indexAv4Jgv8zCSMeta } from "/var/www/homedelimercado.com/pages/Profile/Beneficiaries/index.vue?macro=true";
import { default as indexyLakLuUDjuMeta } from "/var/www/homedelimercado.com/pages/Profile/index.vue?macro=true";
import { default as indext3Ayy2vSTiMeta } from "/var/www/homedelimercado.com/pages/Profile/Orders/index.vue?macro=true";
import { default as _91id_93oLdaDnaZv3Meta } from "/var/www/homedelimercado.com/pages/Profile/shopping_card/[id].vue?macro=true";
import { default as indexEzHYOALxxeMeta } from "/var/www/homedelimercado.com/pages/Profile/shopping_card/index.vue?macro=true";
import { default as _91id_93nllqzJCgkDMeta } from "/var/www/homedelimercado.com/pages/Profile/shopping_card/recharge/[id].vue?macro=true";
import { default as indexE8koMkp36jMeta } from "/var/www/homedelimercado.com/pages/return-policy/index.vue?macro=true";
import { default as index64tFmjqBcSMeta } from "/var/www/homedelimercado.com/pages/shipment-policy/index.vue?macro=true";
import { default as indexcb28ZJOfMSMeta } from "/var/www/homedelimercado.com/pages/shopping-card-info/index.vue?macro=true";
import { default as indexuGHxCdfW50Meta } from "/var/www/homedelimercado.com/pages/store/index.vue?macro=true";
import { default as indexosJARawj8gMeta } from "/var/www/homedelimercado.com/pages/terms-conditions/index.vue?macro=true";
import { default as indexRGGpTseA7gMeta } from "/var/www/homedelimercado.com/pages/warranty-policy/index.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/var/www/homedelimercado.com/pages/[...slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/var/www/homedelimercado.com/pages/404.vue")
  },
  {
    name: "admin-analytics-Login",
    path: "/admin/analytics/Login",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Login.vue")
  },
  {
    name: "admin-analytics-MostSold",
    path: "/admin/analytics/MostSold",
    meta: MostSoldgtHYmw0q6xMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/MostSold.vue")
  },
  {
    name: "admin-analytics-Partials-Accesses",
    path: "/admin/analytics/Partials/Accesses",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Partials/Accesses.vue")
  },
  {
    name: "admin-analytics-Partials-NewUsers",
    path: "/admin/analytics/Partials/NewUsers",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Partials/NewUsers.vue")
  },
  {
    name: "admin-analytics-Partials-PagesMostVisited",
    path: "/admin/analytics/Partials/PagesMostVisited",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Partials/PagesMostVisited.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsAggregatedCart",
    path: "/admin/analytics/Partials/ProductsAggregatedCart",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Partials/ProductsAggregatedCart.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsMostSold",
    path: "/admin/analytics/Partials/ProductsMostSold",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Partials/ProductsMostSold.vue")
  },
  {
    name: "admin-analytics-Partials-ProductsMostVisited",
    path: "/admin/analytics/Partials/ProductsMostVisited",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Partials/ProductsMostVisited.vue")
  },
  {
    name: "admin-analytics-Partials-SalesBehaviour",
    path: "/admin/analytics/Partials/SalesBehaviour",
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Partials/SalesBehaviour.vue")
  },
  {
    name: "admin-analytics-Sales",
    path: "/admin/analytics/Sales",
    meta: SalesDh3QE6G8JYMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Sales.vue")
  },
  {
    name: "admin-analytics-Visits",
    path: "/admin/analytics/Visits",
    meta: VisitsUSDEJ1errWMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/analytics/Visits.vue")
  },
  {
    name: "admin-attributes-id",
    path: "/admin/attributes/:id()",
    meta: _91id_93dl5EoMbMqtMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/attributes/[id].vue")
  },
  {
    name: "admin-attributes-create",
    path: "/admin/attributes/create",
    meta: createY17bcfczxlMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/attributes/create.vue")
  },
  {
    name: "admin-attributes",
    path: "/admin/attributes",
    meta: indexr2AmdIeI3pMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/attributes/index.vue")
  },
  {
    name: "admin-banners-id",
    path: "/admin/banners/:id()",
    meta: _91id_93Ybs8GJgyGhMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/banners/[id].vue")
  },
  {
    name: "admin-banners-create",
    path: "/admin/banners/create",
    meta: createhRtx251CzYMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/banners/create.vue")
  },
  {
    name: "admin-banners",
    path: "/admin/banners",
    meta: indexYfsDhnQaLIMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/banners/index.vue")
  },
  {
    name: "admin-blogs-categories-id",
    path: "/admin/blogs/categories/:id()",
    meta: _91id_93SkE0OmwTkDMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/categories/[id].vue")
  },
  {
    name: "admin-blogs-categories-create",
    path: "/admin/blogs/categories/create",
    meta: createolJvQk2mdCMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/categories/create.vue")
  },
  {
    name: "admin-blogs-categories",
    path: "/admin/blogs/categories",
    meta: index1lX5T0n5QYMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/categories/index.vue")
  },
  {
    name: "admin-blogs-keywords-id",
    path: "/admin/blogs/keywords/:id()",
    meta: _91id_935qpHQGCj5UMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/keywords/[id].vue")
  },
  {
    name: "admin-blogs-keywords-create",
    path: "/admin/blogs/keywords/create",
    meta: createiMUvC056jHMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/keywords/create.vue")
  },
  {
    name: "admin-blogs-keywords",
    path: "/admin/blogs/keywords",
    meta: indexBYifplEfLKMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/keywords/index.vue")
  },
  {
    name: "admin-blogs-posts-id",
    path: "/admin/blogs/posts/:id()",
    meta: _91id_93A9RvszUyKzMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/posts/[id].vue")
  },
  {
    name: "admin-blogs-posts-create",
    path: "/admin/blogs/posts/create",
    meta: createI7VlMOelhAMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/posts/create.vue")
  },
  {
    name: "admin-blogs-posts",
    path: "/admin/blogs/posts",
    meta: indexV7941fcYpsMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/blogs/posts/index.vue")
  },
  {
    name: "admin-brands-id",
    path: "/admin/brands/:id()",
    meta: _91id_93eLBeJS49luMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/brands/[id].vue")
  },
  {
    name: "admin-brands-create",
    path: "/admin/brands/create",
    meta: createkYo8Ay7voiMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/brands/create.vue")
  },
  {
    name: "admin-brands",
    path: "/admin/brands",
    meta: indexp9UtDZ7fOdMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/brands/index.vue")
  },
  {
    name: "admin-categories-id",
    path: "/admin/categories/:id()",
    meta: _91id_932kT1mgIb4kMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/categories/[id].vue")
  },
  {
    name: "admin-categories-Create",
    path: "/admin/categories/Create",
    meta: CreateTOZKH2eCPkMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/categories/Create.vue")
  },
  {
    name: "admin-categories",
    path: "/admin/categories",
    meta: indexWUnTdzkqTtMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/categories/index.vue")
  },
  {
    name: "admin-coins-id",
    path: "/admin/coins/:id()",
    meta: _91id_93jqF1tTyXyAMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/coins/[id].vue")
  },
  {
    name: "admin-coins-create",
    path: "/admin/coins/create",
    meta: createumKdFWw67sMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/coins/create.vue")
  },
  {
    name: "admin-coins",
    path: "/admin/coins",
    meta: indexezTllIlrBJMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/coins/index.vue")
  },
  {
    name: "admin-criterias",
    path: "/admin/criterias",
    meta: indexsXtFRMrOzSMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/criterias/index.vue")
  },
  {
    name: "admin-exchangeRates-create",
    path: "/admin/exchangeRates/create",
    meta: createv9nIl2VwjxMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/exchangeRates/create.vue")
  },
  {
    name: "admin-exchangeRates-CreateBatch",
    path: "/admin/exchangeRates/CreateBatch",
    component: () => import("/var/www/homedelimercado.com/pages/admin/exchangeRates/CreateBatch.vue")
  },
  {
    name: "admin-exchangeRates-Edit",
    path: "/admin/exchangeRates/Edit",
    component: () => import("/var/www/homedelimercado.com/pages/admin/exchangeRates/Edit.vue")
  },
  {
    name: "admin-exchangeRates",
    path: "/admin/exchangeRates",
    meta: indexhDq11jBTADMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/exchangeRates/index.vue")
  },
  {
    name: "admin-gift_Cards-id",
    path: "/admin/gift_Cards/:id()",
    meta: _91id_93kD6Uny2kAyMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/gift_Cards/[id].vue")
  },
  {
    name: "admin-gift_Cards-create",
    path: "/admin/gift_Cards/create",
    meta: createqWGfdP8GgbMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/gift_Cards/create.vue")
  },
  {
    name: "admin-gift_Cards",
    path: "/admin/gift_Cards",
    meta: indexJ0uADUlgeCMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/gift_Cards/index.vue")
  },
  {
    name: "admin-invoices-Create",
    path: "/admin/invoices/Create",
    meta: CreateiVHcUX2nPYMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/invoices/Create.vue")
  },
  {
    name: "admin-invoices",
    path: "/admin/invoices",
    meta: index3rD5GmPOH7Meta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/invoices/index.vue")
  },
  {
    name: "admin-offers-id",
    path: "/admin/offers/:id()",
    meta: _91id_93NTnDOnRkYMMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/offers/[id].vue")
  },
  {
    name: "admin-offers-Create",
    path: "/admin/offers/Create",
    meta: CreatezH3XijcUTTMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/offers/Create.vue")
  },
  {
    name: "admin-offers",
    path: "/admin/offers",
    meta: indexRHn7yVXCWvMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/offers/index.vue")
  },
  {
    name: "admin-order_status-id",
    path: "/admin/order_status/:id()",
    meta: _91id_93aSQvdUWYwgMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/order_status/[id].vue")
  },
  {
    name: "admin-order_status-create",
    path: "/admin/order_status/create",
    meta: createpr5VBxb7qKMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/order_status/create.vue")
  },
  {
    name: "admin-order_status",
    path: "/admin/order_status",
    meta: indexDhjiStlgZdMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/order_status/index.vue")
  },
  {
    name: "admin-orders-order-show",
    path: "/admin/orders/:order()/show",
    meta: showaQL3943AhYMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/orders/[order]/show.vue")
  },
  {
    name: "admin-orders",
    path: "/admin/orders",
    meta: indexvkmvLTGW5eMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/orders/index.vue")
  },
  {
    name: "admin-point_of_sales-id",
    path: "/admin/point_of_sales/:id()",
    meta: _91id_93mRERI9GZe0Meta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/point_of_sales/[id].vue")
  },
  {
    name: "admin-point_of_sales-create",
    path: "/admin/point_of_sales/create",
    meta: createEiKzcJpZuEMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/point_of_sales/create.vue")
  },
  {
    name: "admin-point_of_sales",
    path: "/admin/point_of_sales",
    meta: indexUICyTJAwuPMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/point_of_sales/index.vue")
  },
  {
    name: "admin-products-slug-edit",
    path: "/admin/products/:slug()/edit",
    meta: editSlGiIsKwvZMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/products/[slug]/edit.vue")
  },
  {
    name: "admin-products-Create",
    path: "/admin/products/Create",
    meta: Createa9uRdbm4FKMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/products/Create.vue")
  },
  {
    name: "admin-products-list",
    path: "/admin/products/list",
    meta: listxWKWPXlpjYMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/products/list.vue")
  },
  {
    name: "admin-reports-catalog",
    path: "/admin/reports/catalog",
    meta: indexucPhkXmJqFMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/catalog/index.vue")
  },
  {
    name: "admin-reports-inventory",
    path: "/admin/reports/inventory",
    meta: indexbmcUlIBzcMMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/inventory/index.vue")
  },
  {
    name: "admin-reports-movements",
    path: "/admin/reports/movements",
    meta: indexUlDQD2qFO4Meta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/movements/index.vue")
  },
  {
    name: "admin-reports-orders",
    path: "/admin/reports/orders",
    meta: indexmA76iQVHiOMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/orders/index.vue")
  },
  {
    name: "admin-reports-sale",
    path: "/admin/reports/sale",
    meta: indexarMCXkb22OMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/sale/index.vue")
  },
  {
    name: "admin-reports-salesaccounting",
    path: "/admin/reports/salesaccounting",
    meta: indexzOVIDtlvOhMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/salesaccounting/index.vue")
  },
  {
    name: "admin-reports-soldProduct",
    path: "/admin/reports/soldProduct",
    meta: indexhSwh6VqFbXMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/soldProduct/index.vue")
  },
  {
    name: "admin-reports-unify_sale",
    path: "/admin/reports/unify_sale",
    meta: indexgw9nznGjK1Meta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reports/unify_sale/index.vue")
  },
  {
    name: "admin-reviews",
    path: "/admin/reviews",
    meta: indexA11LGoXs90Meta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/reviews/index.vue")
  },
  {
    name: "admin-roles-id",
    path: "/admin/roles/:id()",
    meta: _91id_932l68WQIXtvMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/roles/[id].vue")
  },
  {
    name: "admin-roles-Create",
    path: "/admin/roles/Create",
    meta: CreateCIhX8Qwu7kMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/roles/Create.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: indexNTb7xfKfxJMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/roles/index.vue")
  },
  {
    name: "admin-sales_buy_card",
    path: "/admin/sales_buy_card",
    meta: indexNvs3aFOcGOMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/sales_buy_card/index.vue")
  },
  {
    name: "admin-settings-Customization",
    path: "/admin/settings/Customization",
    meta: CustomizationuHy6mXphSvMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Customization.vue")
  },
  {
    name: "admin-settings-Generals",
    path: "/admin/settings/Generals",
    meta: GeneralsHurC1YHTsAMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Generals.vue")
  },
  {
    name: "admin-settings-Partials-Contacts",
    path: "/admin/settings/Partials/Contacts",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/Contacts.vue")
  },
  {
    name: "admin-settings-Partials-FrequentAsks",
    path: "/admin/settings/Partials/FrequentAsks",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/FrequentAsks.vue")
  },
  {
    name: "admin-settings-Partials-InformationSection",
    path: "/admin/settings/Partials/InformationSection",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/InformationSection.vue")
  },
  {
    name: "admin-settings-Partials-LocalPickup",
    path: "/admin/settings/Partials/LocalPickup",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/LocalPickup.vue")
  },
  {
    name: "admin-settings-Partials-Misc",
    path: "/admin/settings/Partials/Misc",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/Misc.vue")
  },
  {
    name: "admin-settings-Partials-Miscellaneous",
    path: "/admin/settings/Partials/Miscellaneous",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/Miscellaneous.vue")
  },
  {
    name: "admin-settings-Partials-Notifications",
    path: "/admin/settings/Partials/Notifications",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/Notifications.vue")
  },
  {
    name: "admin-settings-Partials-PayFormItem",
    path: "/admin/settings/Partials/PayFormItem",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/PayFormItem.vue")
  },
  {
    name: "admin-settings-Partials-PayForms",
    path: "/admin/settings/Partials/PayForms",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/PayForms.vue")
  },
  {
    name: "admin-settings-Partials-ProductsInventary",
    path: "/admin/settings/Partials/ProductsInventary",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/ProductsInventary.vue")
  },
  {
    name: "admin-settings-Partials-RelatedProductStrategies",
    path: "/admin/settings/Partials/RelatedProductStrategies",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/RelatedProductStrategies.vue")
  },
  {
    name: "admin-settings-Partials-ScheduleForm",
    path: "/admin/settings/Partials/ScheduleForm",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/ScheduleForm.vue")
  },
  {
    name: "admin-settings-Partials-ScheduleStore",
    path: "/admin/settings/Partials/ScheduleStore",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/ScheduleStore.vue")
  },
  {
    name: "admin-settings-Partials-Shipment",
    path: "/admin/settings/Partials/Shipment",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/Shipment.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentProvince",
    path: "/admin/settings/Partials/ShipmentProvince",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/ShipmentProvince.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentSelectLocations",
    path: "/admin/settings/Partials/ShipmentSelectLocations",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/ShipmentSelectLocations.vue")
  },
  {
    name: "admin-settings-Partials-ShipmentUnitRange",
    path: "/admin/settings/Partials/ShipmentUnitRange",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/ShipmentUnitRange.vue")
  },
  {
    name: "admin-settings-Partials-ShoppingCard",
    path: "/admin/settings/Partials/ShoppingCard",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/ShoppingCard.vue")
  },
  {
    name: "admin-settings-Partials-Store",
    path: "/admin/settings/Partials/Store",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/Store.vue")
  },
  {
    name: "admin-settings-Partials-TwiceTime",
    path: "/admin/settings/Partials/TwiceTime",
    component: () => import("/var/www/homedelimercado.com/pages/admin/settings/Partials/TwiceTime.vue")
  },
  {
    name: "admin-shopping_card-id",
    path: "/admin/shopping_card/:id()",
    component: () => import("/var/www/homedelimercado.com/pages/admin/shopping_card/[id].vue")
  },
  {
    name: "admin-shopping_card",
    path: "/admin/shopping_card",
    meta: indexVcPqq7LckNMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/shopping_card/index.vue")
  },
  {
    name: "admin-users-id",
    path: "/admin/users/:id()",
    meta: _91id_93Fej4WDtL0aMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/users/[id].vue")
  },
  {
    name: "admin-users-create",
    path: "/admin/users/create",
    meta: create2xH4OYtJCfMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/users/create.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: indexyukLnHmRuSMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/admin/users/index.vue")
  },
  {
    name: "Auth-ConfirmPassword",
    path: "/Auth/ConfirmPassword",
    component: () => import("/var/www/homedelimercado.com/pages/Auth/ConfirmPassword.vue")
  },
  {
    name: "Auth-ForgotPassword",
    path: "/Auth/ForgotPassword",
    component: () => import("/var/www/homedelimercado.com/pages/Auth/ForgotPassword.vue")
  },
  {
    name: "Auth-Login",
    path: "/Auth/Login",
    meta: LoginFkowABroAEMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Auth/Login.vue")
  },
  {
    name: "Auth-Register",
    path: "/Auth/Register",
    meta: RegisterEIahbFB2sFMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Auth/Register.vue")
  },
  {
    name: "Auth-ResetPassword",
    path: "/Auth/ResetPassword",
    component: () => import("/var/www/homedelimercado.com/pages/Auth/ResetPassword.vue")
  },
  {
    name: "Auth-VerifyEmail",
    path: "/Auth/VerifyEmail",
    component: () => import("/var/www/homedelimercado.com/pages/Auth/VerifyEmail.vue")
  },
  {
    name: "blog-blog",
    path: "/blog/:blog()",
    component: () => import("/var/www/homedelimercado.com/pages/blog/[blog].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/var/www/homedelimercado.com/pages/blog/index.vue")
  },
  {
    name: "Cart",
    path: "/Cart",
    component: () => import("/var/www/homedelimercado.com/pages/Cart/index.vue")
  },
  {
    name: "Cart-share-cart-encoded",
    path: "/Cart/share-cart/:encoded()",
    component: () => import("/var/www/homedelimercado.com/pages/Cart/share-cart/[encoded].vue")
  },
  {
    name: "Contact-Us",
    path: "/Contact-Us",
    component: () => import("/var/www/homedelimercado.com/pages/Contact-Us/index.vue")
  },
  {
    name: "Distribution-Index",
    path: "/Distribution/Index",
    component: () => import("/var/www/homedelimercado.com/pages/Distribution/Index.vue")
  },
  {
    name: "ExchangeRates-Create",
    path: "/ExchangeRates/Create",
    component: () => import("/var/www/homedelimercado.com/pages/ExchangeRates/Create.vue")
  },
  {
    name: "ExchangeRates-CreateBatch",
    path: "/ExchangeRates/CreateBatch",
    component: () => import("/var/www/homedelimercado.com/pages/ExchangeRates/CreateBatch.vue")
  },
  {
    name: "ExchangeRates-Edit",
    path: "/ExchangeRates/Edit",
    component: () => import("/var/www/homedelimercado.com/pages/ExchangeRates/Edit.vue")
  },
  {
    name: "ExchangeRates-Index",
    path: "/ExchangeRates/Index",
    component: () => import("/var/www/homedelimercado.com/pages/ExchangeRates/Index.vue")
  },
  {
    name: "Frequent-Ask",
    path: "/Frequent-Ask",
    component: () => import("/var/www/homedelimercado.com/pages/Frequent-Ask/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/homedelimercado.com/pages/index.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/var/www/homedelimercado.com/pages/info.vue")
  },
  {
    name: "information-InformationPage",
    path: "/information/:InformationPage()",
    component: () => import("/var/www/homedelimercado.com/pages/information/[InformationPage].vue")
  },
  {
    name: "Offers",
    path: "/Offers",
    component: () => import("/var/www/homedelimercado.com/pages/Offers/index.vue")
  },
  {
    name: "orders-order-error-page",
    path: "/orders/:order()/error-page",
    component: () => import("/var/www/homedelimercado.com/pages/orders/[order]/error-page.vue")
  },
  {
    name: "orders-order-redirect-page",
    path: "/orders/:order()/redirect-page",
    meta: redirect_45pagez8hSCWKOFHMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/orders/[order]/redirect-page.vue")
  },
  {
    name: "orders-order-show",
    path: "/orders/:order()/show",
    meta: showMQvpG22Bw5Meta || {},
    component: () => import("/var/www/homedelimercado.com/pages/orders/[order]/show.vue")
  },
  {
    name: "orders-order-success-page",
    path: "/orders/:order()/success-page",
    component: () => import("/var/www/homedelimercado.com/pages/orders/[order]/success-page.vue")
  },
  {
    name: "payment_shopping_card-id",
    path: "/payment_shopping_card/:id()",
    component: () => import("/var/www/homedelimercado.com/pages/payment_shopping_card/[id].vue")
  },
  {
    name: "Products-product",
    path: "/Products/:product()",
    component: () => import("/var/www/homedelimercado.com/pages/Products/[product].vue")
  },
  {
    name: "Products-slug-edit",
    path: "/Products/:slug()/edit",
    component: () => import("/var/www/homedelimercado.com/pages/Products/[slug]/edit.vue")
  },
  {
    name: "Products-Create",
    path: "/Products/Create",
    meta: CreateNH34B29vxYMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Products/Create.vue")
  },
  {
    name: "Products-Index",
    path: "/Products/Index",
    meta: IndexDfZAfuukUwMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Products/Index.vue")
  },
  {
    name: "Products-Review-Read-product",
    path: "/Products/Review/Read/:product()",
    component: () => import("/var/www/homedelimercado.com/pages/Products/Review/Read/[product].vue")
  },
  {
    name: "Products-Review-Write-product",
    path: "/Products/Review/Write/:product()",
    component: () => import("/var/www/homedelimercado.com/pages/Products/Review/Write/[product].vue")
  },
  {
    name: "Products-SuccessPage",
    path: "/Products/SuccessPage",
    component: () => import("/var/www/homedelimercado.com/pages/Products/SuccessPage.vue")
  },
  {
    name: "Profile-Beneficiaries",
    path: "/Profile/Beneficiaries",
    meta: indexAv4Jgv8zCSMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Profile/Beneficiaries/index.vue")
  },
  {
    name: "Profile",
    path: "/Profile",
    meta: indexyLakLuUDjuMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Profile/index.vue")
  },
  {
    name: "Profile-Orders",
    path: "/Profile/Orders",
    meta: indext3Ayy2vSTiMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Profile/Orders/index.vue")
  },
  {
    name: "Profile-shopping_card-id",
    path: "/Profile/shopping_card/:id()",
    meta: _91id_93oLdaDnaZv3Meta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Profile/shopping_card/[id].vue")
  },
  {
    name: "Profile-shopping_card",
    path: "/Profile/shopping_card",
    meta: indexEzHYOALxxeMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Profile/shopping_card/index.vue")
  },
  {
    name: "Profile-shopping_card-recharge-id",
    path: "/Profile/shopping_card/recharge/:id()",
    meta: _91id_93nllqzJCgkDMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/Profile/shopping_card/recharge/[id].vue")
  },
  {
    name: "return-policy",
    path: "/return-policy",
    component: () => import("/var/www/homedelimercado.com/pages/return-policy/index.vue")
  },
  {
    name: "shipment-policy",
    path: "/shipment-policy",
    component: () => import("/var/www/homedelimercado.com/pages/shipment-policy/index.vue")
  },
  {
    name: "shopping-card-info",
    path: "/shopping-card-info",
    meta: indexcb28ZJOfMSMeta || {},
    component: () => import("/var/www/homedelimercado.com/pages/shopping-card-info/index.vue")
  },
  {
    name: "store",
    path: "/store",
    component: () => import("/var/www/homedelimercado.com/pages/store/index.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/var/www/homedelimercado.com/pages/terms-conditions/index.vue")
  },
  {
    name: "warranty-policy",
    path: "/warranty-policy",
    component: () => import("/var/www/homedelimercado.com/pages/warranty-policy/index.vue")
  }
]